<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1> Payout Details</h1>
            <span> We will use the business details to automate the invoicing and
              payment process. Please ensure details are correct to avoid any
              delays in payment.</span>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
          </div>
        </div>

        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
          @keyup.enter="goNext('userForm')">
          <div class="form_text">

          </div>
          <el-form-item class="no-scroll" prop="businessName" :required="true">
            <div class="el-input">
              <el-input v-model="formsData.userForm.businessName.value" :placeholder="'Business Name'"
              @change="checkFormValidation('userForm', false, 'businessName')"
              @blur="checkFormValidation('userForm', true, 'businessName')"
              @keyup="formsData.userForm.businessName.value = $event.target.value"></el-input>
            </div>
            
          </el-form-item>
          <el-form-item class="no-scroll" prop="abn" :required="true">
            <div class="el-input">
              <input type="tel" class="el-input__inner" :ref="(el) => (formsData.userForm.abn.ref = el)"
                :value="formsData.userForm.abn.value" placeholder="ABN" v-imask="formsData.userForm.abn.mask"
                @accept="onFormMaskAccept($event, 'userForm', 'abn')"
                @blur="checkFormValidation('userForm', true, 'abn')" />
            </div>
          </el-form-item>
          <el-form-item prop="billing_type" :required="true">
            <el-select popper-class="normal-select" class="covid-cert-select" style="width: 100%"
              :ref="(el) => (formsData.userForm.billing_type.ref = el)" v-model="formsData.userForm.billing_type.value"
              @change="checkFormValidation('userForm', true, 'billingType')" placeholder="Select Entity Type">
              <el-option label="Company / Trust / Partnership" :value="1" />
              <el-option label="Sole Trader" :value="2" />
            </el-select>
          </el-form-item>
          <div class="form_text text-center">
            <div class="text_note">
              Dont have ABN ?
              <a href=" https://www.abr.gov.au/business-super-funds-charities/applying-abn " target="_blank">Sign up
                here</a>
            </div>
          </div>
          <div class="form_text">
            <div class="text">Bank Details</div>
          </div>
          <el-form-item label="Bank Name" prop="bankName" :required="true">
            <el-select popper-class="normal-select" style="width: 100%" filterable v-model="formsData.userForm.bankName.value"
              placeholder="Select Bank">
              <el-option v-for="item in banks" :key="item.id" :label="item.bankName" :value="item.bankName" />
            </el-select>
          </el-form-item>
          <el-form-item prop="bankAccountName" :required="true">
            <din class="el-input">
              <el-input v-model="formsData.userForm.bankAccountName.value" :placeholder="'Account Name'"></el-input>
            </din>
          </el-form-item>
          <el-form-item prop="bsb" class="no-scroll">
            <div class="el-input">
              <input type="tel" class="el-input__inner" :value="formsData.userForm.bsb.value" placeholder="BSB"
                v-imask="formsData.userForm.bsb.mask" @accept="onFormMaskAccept($event, 'userForm', 'bsb')"
                @blur="checkFormValidation('userForm', true, 'bsb')" />
            </div>
          </el-form-item>
          <el-form-item class="no-scroll" prop="bankAccountNumber" :required="true">
            <div class="el-input">
              <input type="tel" class="el-input__inner" :value="formsData.userForm.bankAccountNumber.value"
                placeholder="Bank Account Number" v-imask="formsData.userForm.bankAccountNumber.mask"
                @accept="onFormMaskAccept($event, 'userForm', 'bankAccountNumber')"
                @blur="checkFormValidation('userForm', true, 'bankAccountNumber')" />
            </div>
          </el-form-item>
          <el-form-item class="button_submit mb0">
            <el-button class="submit" type="blue" @click="goNext('userForm')"
              :disabled="!formsData.userForm.isFormValid">
              Continue
            </el-button>
          </el-form-item>
        </el-form>
        <div class="background-circles">
          <div class="circle circle-2"></div>
          <div class="circle circle-1"></div>
          <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessageBox } from "@/components/Vendor/Element";
import { onMounted, inject, ref } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useStore } from "vuex";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject("setPageClassGlobal");

    const userData = $store.getters.GET_USER_DATA;
    const userSuper = userData.locumSuper;
    const billing = userData.billing;
    const banks = ref([]);
    const routeName = $route.name;

    const formsDataArray = {
      userForm: {
        isFormValid: true,
        bankName: {
          value: userData.bankNameBilling  ? userData.bankNameBilling : null,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bankName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        businessName: {
          value: userData.businessNameBilling ? userData.businessNameBilling : "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "businessName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        abn: {
          value: userData.abn
            ? IMask.createMask(formMasks.abn).resolve(userData.abn)
            : "",
          mask: formMasks.abn,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "abn",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        billing_type: {
          value: userData.billingAccountType ?  userData.billingAccountType : "",
          resetValue: true,
        },
        bankAccountName: {
          value: billing.bankAccountName || "",
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bankAccountName",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        bsb: {
          value: billing.bankBsb
            ? IMask.createMask(formMasks.bsb).resolve(billing.bankBsb)
            : "",
          mask: formMasks.bsb,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bsb",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        bankAccountNumber: {
          value: billing.bankAccountNumber
            ? IMask.createMask(formMasks.bankAccountNumber).resolve(
              billing.bankAccountNumber
            )
            : "",
          mask: formMasks.bankAccountNumber,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "bankAccountNumber",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    async function getBanks() {
      const allBanks = await $store.dispatch("GET_ALL_BANK");
      banks.value = allBanks.data;
    }

    const goBack = async() => {
      await $store.dispatch("getAuthPageBack");
      $router.push({
          name: "onboard_address",
      });      
    };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
                console.log(getFormValues(formName));
                const formValues = getFormValues(formName);
                await $store.dispatch(
                  "SAVE_USER_DATA",
                  getFormValues(formName)
                );
                await $store.dispatch("addAuthPageBack", $route.name);
                if(formValues.billing_type === 2){
                  $router.push({
                  name: "onboard_super",
                });
                }else{
                  $router.push({
                  name: "onboard_gst",
                });
                }
              
              
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    const skip = () => {
      (async () => {
        try {
          await ElMessageBox.confirm(
            ``,
            "Do you want to skip? You will be unverified",
            {
              distinguishCancelAndClose: true,
              showConfirmButton: true,
              confirmButtonText: "Skip",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--green",
              cancelButtonClass: "el-button--grey",
              showClose: true,
            }
          );
        } catch {
          return;
        }
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
          $router.push({
            name: "onboard_gst",
          });
        } catch (error) {
          console.log(error);
        }
      })();
    };

    onBeforeRouteLeave((to, from, next) => {
      if (routeName == "profile_payout") {
        (async () => {
          try {
            let leave = await checkFormChanged("userForm");
            if (leave == "save") {
              await goNext("userForm");
            } else if (!leave) {
              next(false);
            } else {
              next();
            }
          } catch (error) {
            next(false);
            console.log(error);
          }
        })();
      } else {
        next();
      }
    });

    onMounted(() => {
      setPageClassGlobal("global_onboard_internal_page");
      setFormRefs();
      getBanks();
      formsRefs.userForm.value.$el[0].focus();
      checkFormValidation("userForm", false);
      if (userData.abn) {
        checkFormValidation('userForm', true, 'abn')
      }
    });

    const {
      ["onFormMaskAccept"]: onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      checkFormChanged,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      goNext,
      skip,
      banks,
      routeName,
      userSuper
    };
  },
};
</script>